import React from "react";
import Slider from "react-slick";
import slider1 from '../../assets/slider-image-1.jpeg';
import slider2 from '../../assets/slider-image-2.jpeg';
import slider3 from '../../assets/slider-image-3.jpeg';
import slider4 from '../../assets/slider-2.jpeg';
import slider5 from '../../assets/grocery-banner-2.jpeg';
import slider6 from '../../assets/grocery-banner.png';
export default function OfferSlider()
 {

    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        pauseOnHover: true,
        arrows:false
      };



  return <>

  <div className="container">
  <Slider {...settings} className="text-center slide1 pt-4 cursor-pointer">
      
  <img src={slider1} className="w-100 "  />
  
      
      <img src={slider2}  className="w-100" />
      
      <img src={slider3}  className="w-100" />
      
      <img src={slider4}  className="w-100" />
      
      <img src={slider5}  className="w-100" />
      
      <img src={slider6}   className="w-100"/>
      
    </Slider>
    </div>
  
  </>
}
